/**
 * Format amount in NOK with proper Norwegian formatting
 *
 * @param amount - Amount in NOK (not øre)
 * @returns Formatted string (e.g., "2 990 kr")
 */
export const formatNOK = (amount: number): string => {
  return new Intl.NumberFormat('nb-NO', {
    style: 'currency',
    currency: 'NOK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};
